<template>
  <div class="select-role-popup">
    <div class="popup-shadow" @click="hideSelectRolePopup"></div>
    <div class="popup-container">
      <div class="title">
        {{ letter.selectRoleName }}
        <span @click="handleGoLogOut" class="logout" v-if="!isInWebview">{{
          letter.logout
        }}</span>
      </div>
      <div class="popup-tips" v-if="gameId == 251">
        <p>海神幣需要在登入遊戲後才能購買，請登入遊戲後再刷新當前頁面</p>
        <p>登錄有效時間：當日05:00-次日04:59</p>
      </div>
      <role-select isPopup="true"></role-select>
      <div
        class="pre-store-info"
        v-show="
          lastedGame == gameId && lastedServerId && getCurLastedServerName
        "
      >
        <span
          >{{ letter.previousSelect }}：{{ getCurLastedServerName }} -
          {{ lastedRoleName }}</span
        >
        <span class="again-role j-again-role" @click="setLastedServerId"
          >{{ letter.payAgainBtn }}>></span
        >
      </div>
      <div class="popup-close" @click="hideSelectRolePopup"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
import RoleSelect from '@components/officialWebStore/login/RoleSelect.vue';
import login from '@mixins/officialWebStore/login';
import { mapState } from 'vuex';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  name: 'SelectRolePopup',
  mixins: [login],
  computed: {
    ...mapState({
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      lastedRoleName: state => state.lastedRoleName,
      lastedServerId: state => state.lastedServerId,
      lastedRoleId: state => state.lastedRoleId,
      lastedGame: state => state.lastedGame,
      loginAccount: state => state.login.loginAccount,
      letter: state => state.letter,
      isInWebview: state => state.isInWebview
    }),
    getCurLastedServerName() {
      let res = '';
      if (!this.serverList || this.lastedGame != this.gameId) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.lastedServerId) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    }
  },
  methods: {
    setLastedServerId() {
      clickButton({
        btnName: 'store_again',
        locationKey: locationType.charPopup
      });
      this.serverId = this.lastedServerId;
      this.roleId = this.lastedRoleId;
      this.loadRole();
    },
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.charPopup
      });
      this.goLogOut();
    }
  },
  components: {
    RoleSelect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.select-role-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
}

.title {
  text-align: left;
  height: 87px;
  line-height: 87px;
  font-size: 26px;
  @include g-popup-title();
  margin: 0;
  border-radius: 10px;
  padding-left: 64px;
}
.popup-tips {
  margin-top: 10px;
  font-size: 18px;
  line-height: 24px;
  color: #333;
  padding-left: 65px;
}

.logout {
  display: inline-block;
  height: 45px;
  line-height: 45px;
  padding: 0 20px;
  font-size: 22px;
  color: #333;
  text-align: center;
  margin-left: 20px;
  border-radius: 30px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #d2d2d2;
}

.popup-close {
  position: absolute;
  right: 32px;
  top: 27px;
  background: url($tmslgImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.pre-store-info {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #333;
  padding: 0 64px 57px;
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
  }
  .popup-tips {
    padding-left: 20px;
  }
  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
    padding-left: 20px;
  }
  .select-wrap {
    padding: 20px;
    ::v-deep .row-item {
      width: 100%;
      font-size: 18px;
    }
  }
  .pre-store-info {
    padding: 0 20px 20px;
    font-size: 16px;
  }
  .popup-close {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
}
</style>
